import {images} from '../constant'

const ProjectsList = [
    {
        "uid":"cc95526f-fa88-4bce-91f6-7571aeaf3b0a",
        "title":"Cyber Security",
        "subtitle":"Security",
        "url":"https://github.com/hhphu/InfoSec",
        "image": images.hackthebox
    },
    {
        "uid":"23dca6ac-164f-44d6-a389-121b110de93d",
        "title":"Cloud",
        "subtitle":"Cybersecurity, Cloud Security",
        "url":"https://github.com/hhphu/hhphu-cloud",
        "image": images.hhphu
    },
    {
        "uid":"a816d2d0-b024-4e4e-b9d9-bba6977e6544",
        "title":"Security Cheatsheets",
        "subtitle":"Cloud, Cybersecurity, DevOps",
        "url":"https://cheatsheets.hhphu.com/",
        "image": images.cheatsheets
    },
    {
        "uid":"0a9a5146-115f-494b-8b37-88a63a93db59",
        "title":"Personal Blogs",
        "subtitle":"Security, Blogs",
        "url":"https://www.hqphu.com/posts/6kAWd9Mm6i9jXrkiE90tct",
        "image": images.hqphu
    },
]

export default ProjectsList;
